import { useTheme } from '@mui/system';
import useMediaQuery from '@mui/material/useMediaQuery';
import OnBoardingLayout from './modules/onboarding/components/layout';
import { useNavigate } from 'react-router-dom';
import {
    CustomersStepTypeEnumPaths
} from '@/shared/endpoints/customers';
import { Button } from '@/shared/ui';
import { ABSOLUTE_ROUTES } from './shared/constants/routes';
import Actor0 from '@/assets/images/onboarding/review_people/actor-0.svg';
import Actor1 from '@/assets/images/onboarding/review_people/size 5.svg';
import Actor2 from '@/assets/images/onboarding/review_people/actor-2.svg';
import Actor3 from '@/assets/images/onboarding/review_people/actor-3.svg';
import Actor4 from '@/assets/images/onboarding/review_people/actor-4.svg';
import Actor5 from '@/assets/images/onboarding/review_people/actor-5.svg';
import Actor6 from '@/assets/images/onboarding/review_people/actor-6.svg';
import Actor7 from '@/assets/images/onboarding/review_people/actor-7.svg';
import Actor8 from '@/assets/images/onboarding/review_people/actor-8.svg';
import Actor9 from '@/assets/images/onboarding/review_people/actor-9.svg';
import Bottom from '@/assets/images/onboarding/review_people/bottom-test.svg';

import useLogoutWithStoreReset from './shared/hooks/useResetStore.ts';

const actorsWithProps = [
    { src: Actor0, preshrink: 'h-[180px]' },
    { src: Actor1, preshrink: 'h-[180px]' },
    { src: Actor2 },
    { src: Actor3 },
    { src: Actor4 },
    { src: Actor5 },
    { src: Actor6 },
    { src: Actor7 },
    { src: Actor8, preshrink: 'h-[180px]' },
    { src: Actor9 },
];

const actorsBelowSm = [
    { src: Actor0, preshrink: 'h-[150px]' },
    { src: Actor6 },
    { src: Actor7, preshrink: 'h-[150px]' },
    { src: Actor5 },
]

const Blocked = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const isLessThan1500 = useMediaQuery('(max-width:1700px)');
    const isLessThan576 = useMediaQuery('(max-width:576px)');
    const isBelowXl = useMediaQuery(theme.breakpoints.down('xl'));
    const isBelowLg = useMediaQuery(theme.breakpoints.down('lg'));
    const isBelowSm = useMediaQuery(theme.breakpoints.down('sm'));
    const logoutWithStoreReset = useLogoutWithStoreReset();

    let start = 0;
    let end = actorsWithProps.length;

    // Remove one from front and back depending on breakpoint
    if (isLessThan1500) {
        start += 1;
        end -= 1;
    }

    if (isBelowXl) {
        start += 1;
        end -= 1;
    }

    // if (isBelowLg) {
    //     start += 1;
    //     end -= 1;
    // }

    const individualStyle = (actor, index) => {
        if (actor.preshrink) {
            return actor.preshrink;
        } else if (index % 2 !== 0 && isBelowLg) {
            return `h-[100px] ${isBelowSm ? 'translate-y-[-3rem]' : ''}`;
        } else {
            return 'h-[200px]';
        }
    }

    const handleLogout = () => {
        logoutWithStoreReset();
    }

    const buttonPadding = isLessThan576 ? '12px !important' : '17px !important';

    const visibleActors = isBelowSm ? actorsBelowSm : actorsWithProps.slice(start, end);

    return (
        <OnBoardingLayout step={CustomersStepTypeEnumPaths.ABOUT_YOU} spacings={false}>
            <div className='w-full flex flex-col items-center justify-center pt-[2.8125rem] gradient-up'>
                <div className='px-[1.4722rem]'>
                    <div className='flex flex-col items-center justify-center h-full text-center max-w-[49.5rem] gap-[30px] sm:gap-[45px]'>
                        <div className='flex flex-col gap-[15px] sm:gap-[20px]'>
                            <h3 className='block font-agrandir text-30 sm:text-50 leading-[130%]'>
                                We’re&nbsp;Grateful&nbsp;for <br /> Your&nbsp;Interest
                            </h3>
                            <span className='font-atkinsonHyperlegible text-18 sm:text-20 leading-[137%] sm:leading-[140%] text-center'>
                                Our mission is to bring long-term care pharmacy services to seniors who manage complex medication needs. MedBox isn’t the right fit for everyone, and we stay true to our mission by focusing on older adults who benefit most from this level of care. We appreciate your interest and understanding as we dedicate our resources to the seniors who will benefit most from MedBox.
                            </span>
                            <span className='block font-atkinsonHyperlegible  text-18 sm:text-20 leading-[137%] sm:leading-[140%] text-center'>If you think MedBox would benefit you despite this, you can request a review. Please use the form here to share more about your needs.</span>
                        </div>
                        <div className='flex flex-col gap-[15px] w-full items-center justify-center'>
                            <Button
                                fontClassName='leading-[120%] sm:leading-[105%] font-dmSansMedium text-16 sm:text-18 font-bold'
                                sx={{ width: '100%', maxWidth: '27.5rem', paddingTop: buttonPadding, paddingBottom: buttonPadding }}
                                showEndIcon
                                onClick={() => {
                                    window.open('https://ameripharma.typeform.com/to/pvitXWyy', '_blank');
                                }}
                            >
                                <span className='leading-[120%] sm:leading-[105%] font-dmSansMedium text-16 sm:text-18 font-bold'>Request a Review</span>
                            </Button>
                            <Button
                                variant='outlined'
                                sx={{ width: '100%', maxWidth: '27.5rem', paddingTop: buttonPadding, paddingBottom: buttonPadding }}
                                onClick={handleLogout}
                                fontClassName='leading-[120%] sm:leading-[105%] font-dmSansMedium text-16 sm:text-18 font-bold'
                            >
                                <span className='leading-[120%] sm:leading-[105%] font-dmSansMedium text-16 sm:text-18 font-bold'>Exit Account</span>
                            </Button>
                        </div>
                    </div>
                    <div className='w-full flex items-center justify-center mt-[30px] sm:mt-[20px]'>
                        <Button
                            variant='text'
                            type='button'
                            sx={{ width: '100%', maxWidth: '27.5rem'  }}
                            onClick={() => {
                                navigate(ABSOLUTE_ROUTES.ONBOARDING.ABOUT_YOU.DOB_GENDER);
                            }}
                        >
                            <span className='leading-[105%] font-dmSansMedium text-17 font-bold'>Back</span>
                        </Button>
                    </div>
                </div>
                <div className="relative h-[270px] sm:translate-y-10 w-full items-center justify-center flex" >
                    <div className="absolute bottom-[-15px] sm:bottom-[-35px] sm:bottom-[-40px] h-[200px] w-full">
                        <img
                            src={Bottom}
                            className="w-full h-full object-cover"
                            alt="Bottom"
                        />
                        <div className="absolute bottom-[-1rem] sm:bottom-[3rem] left-0 right-0 flex justify-center h-fit overflow-visible">
                            <div className="flex flex-row items-center justify-center gap-2 md:gap-[2rem] h-[300px] overflow-visible">
                                {Array.from({ length: visibleActors.length }, (_, i) => (
                                    <img
                                        key={i}
                                        src={visibleActors[i].src}
                                        className={`${individualStyle(visibleActors[i], i)}`}
                                    />
                                ))}
                            </div>
                        </div>
                        <div className="gradient-box" />
                    </div>
                </div>
            </div>
        </OnBoardingLayout>
    )

}
export default Blocked;